import { t } from "@lingui/macro";
import * as React from "react";
import { Path, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const PersonPlusIcon = (props: IconProps) => (
  <Icon
    viewBox="0 0 16 16"
    fill="none"
    color="currentColor"
    title={t`Person Plus`}
    accessible={false}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fill="currentColor"
        d="M12 8.25a.75.75 0 0 1 .75.75v2.25H15a.75.75 0 0 1 0 1.5h-2.25V15a.75.75 0 0 1-1.5 0v-2.25H9a.75.75 0 0 1 0-1.5h2.25V9a.75.75 0 0 1 .75-.75Zm-4-.5a.75.75 0 0 1 0 1.5H4.5c-.74 0-1.445.28-1.958.77a2.505 2.505 0 0 0-.792 1.813V13.5a.75.75 0 0 1-1.5 0v-1.667c0-1.095.457-2.137 1.258-2.9A4.341 4.341 0 0 1 4.5 7.75H8ZM7.5.25a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5Zm0 1.5a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
